import { Link } from 'react-router-dom';


function Oferta(props) {
    return (<div>


        {props.dietary.name}

    </div>)
}
export default Oferta